var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSafetyPosition(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.64453 11.4538C3.64453 11.5616 3.67425 11.667 3.72994 11.7567C3.78562 11.8463 3.86476 11.9162 3.95737 11.9575C4.04997 11.9987 4.15186 12.0095 4.25016 11.9885C4.34847 11.9675 4.43877 11.9156 4.50964 11.8393C4.58051 11.7631 4.62877 11.6659 4.64833 11.5601C4.66788 11.4544 4.65785 11.3448 4.6195 11.2451C4.58114 11.1455 4.51618 11.0604 4.43284 11.0005C4.3495 10.9406 4.25153 10.9086 4.1513 10.9086C4.01689 10.9086 3.88799 10.966 3.79296 11.0683C3.69792 11.1705 3.64453 11.3092 3.64453 11.4538Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.16012 5.06073L6.71589 7.21948H2.63379C2.63297 6.46307 2.81431 5.71932 3.16012 5.06073Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7187 10.6209C11.7187 10.4763 11.6653 10.3377 11.5703 10.2354C11.4752 10.1332 11.3463 10.0757 11.2119 10.0757H4.56243C4.4281 10.076 4.29935 10.1335 4.20437 10.2357C4.10938 10.3379 4.05591 10.4764 4.05566 10.6209H11.7187Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1182 11.4538C11.1182 11.5616 11.1478 11.6669 11.2035 11.7566C11.2591 11.8462 11.3382 11.9161 11.4308 11.9574C11.5233 11.9987 11.6252 12.0095 11.7234 11.9886C11.8217 11.9676 11.912 11.9158 11.9829 11.8397C12.0538 11.7635 12.1022 11.6665 12.1219 11.5608C12.1415 11.4551 12.1316 11.3455 12.0934 11.2458C12.0552 11.1462 11.9904 11.061 11.9071 11.001C11.8239 10.9409 11.726 10.9088 11.6258 10.9086C11.4914 10.9086 11.3626 10.966 11.2675 11.0683C11.1725 11.1705 11.1191 11.3092 11.1191 11.4538",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.35433 9.37122H4.5625V9.87232H5.35433V9.37122Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25999 8.74188H4.6582V9.24299H5.25999V8.74188Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.16468 8.11145H4.75293V8.61253H5.16468V8.11145Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2128 9.37122H10.4209V9.87232H11.2128V9.37122Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1184 8.74188H10.5166V9.24299H11.1184V8.74188Z",
    fill: "currentColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0231 8.11145H10.6113V8.61253H11.0231V8.11145Z",
    fill: "currentColor"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.96825 9.74805C6.93578 9.74704 6.90425 9.73603 6.87736 9.71638C6.85048 9.69674 6.82941 9.66922 6.8166 9.63712C6.80375 9.60501 6.79973 9.56958 6.80496 9.53511C6.81024 9.50059 6.82454 9.46844 6.84624 9.44237L7.76382 8.29987C7.77911 8.27975 7.79837 8.26353 7.8202 8.25239C7.84203 8.24125 7.86589 8.23547 7.89003 8.23547C7.9142 8.23547 7.93807 8.24125 7.9599 8.25239C7.98173 8.26353 8.00099 8.27975 8.01624 8.29987L8.92827 9.44237C8.95181 9.46728 8.96796 9.49919 8.97455 9.534C8.98113 9.5688 8.97793 9.60496 8.96535 9.63779C8.95272 9.67062 8.93129 9.69867 8.90377 9.71832C8.87626 9.73796 8.84392 9.74829 8.8109 9.74805H6.96825Z",
    fill: "currentColor"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.20121 7.90701H13.5728C13.5992 7.90701 13.6254 7.90141 13.6498 7.89053C13.6742 7.87965 13.6964 7.8637 13.7151 7.8436C13.7337 7.8235 13.7486 7.79964 13.7587 7.77337C13.7688 7.74711 13.774 7.71896 13.774 7.69053V6.06395C13.774 6.00654 13.7528 5.95147 13.7151 5.91088C13.6774 5.87028 13.6262 5.84747 13.5728 5.84747C13.5194 5.84747 13.4682 5.87028 13.4305 5.91088C13.3928 5.95147 13.3716 6.00654 13.3716 6.06395V7.47405H2.40336V6.06395C2.39989 6.00895 2.37713 5.95743 2.33969 5.9198C2.30225 5.88216 2.25292 5.86123 2.20168 5.86123C2.15044 5.86123 2.10112 5.88216 2.06368 5.9198C2.02623 5.95743 2.00348 6.00895 2 6.06395V7.69053C2 7.74794 2.0212 7.803 2.05893 7.8436C2.09667 7.8842 2.14785 7.90701 2.20121 7.90701Z",
    fill: "currentColor"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.51499 11.3616L2.95605 11.086L2.99331 10.9407C3.01819 10.9042 3.05231 10.8761 3.09162 10.8599C3.13092 10.8438 3.17373 10.8401 3.21491 10.8494C3.2561 10.8587 3.29392 10.8805 3.32384 10.9124C3.35377 10.9442 3.37453 10.9847 3.38364 11.0289L3.60815 11.082C3.59187 11.1085 3.57754 11.1363 3.5653 11.1652C3.53893 11.2288 3.52195 11.2964 3.51499 11.3656",
    fill: "currentColor"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.70801 11.1001L4.93997 11.0339C4.94758 10.9892 4.96708 10.9479 4.9961 10.9149C5.02511 10.882 5.0624 10.8588 5.10343 10.8482C5.14446 10.8375 5.18748 10.84 5.22725 10.8552C5.26703 10.8704 5.30185 10.8977 5.3275 10.9337L5.36756 11.077L4.79465 11.3877C4.78926 11.3257 4.77642 11.2647 4.75645 11.2063C4.74334 11.1687 4.72712 11.1325 4.70801 11.098",
    fill: "currentColor"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.67193 5.01544H12.1897C12.5302 5.01544 12.8066 5.33601 12.8066 5.72992V7.06934C12.8066 7.16181 12.743 7.23613 12.6632 7.23613H7.0401C6.96167 7.23613 6.89746 7.16181 6.89746 7.06934L6.89792 7.05438C6.90457 5.92859 7.69825 5.01544 8.67193 5.01544ZM7.16622 6.93077H12.5431V5.72992C12.5431 5.50427 12.3841 5.3208 12.1897 5.3208H8.67193C7.88169 5.3208 7.22745 6.03209 7.16622 6.93077Z",
    fill: "currentColor"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3255 5.06372H10.0098V7.09131H10.3255V5.06372Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafetyPosition);
export default __webpack_public_path__ + "static/media/Safety_position.e1565dac.svg";
export { ForwardRef as ReactComponent };